import { useAppTheme } from "@hooks/useAppTheme";
import { themeRoundnessMultiplier } from "@memorang/ui/src/constants";
/* -----------------Globals--------------- */
import { Image } from "expo-image";
import PraxisSymbol from "../../../assets/praxis-symbol.svg";

type Props = {
	image: string;
	size: number;
	enabledBoxShadow?: boolean;
	showBorder?: boolean;
};

const ProductIcon = (props: Props) => {
	const { size, image } = props;
	const theme = useAppTheme();

	const isPraxis =
		image &&
		(image.includes("icon_dark.png") ||
			image.includes("icon_light.png") ||
			image.includes("praxis"));

	if (isPraxis) {
		return <PraxisSymbol width={size} height={size} />;
	}

	return (
		<Image
			source={{ uri: image }}
			style={{
				width: size,
				height: size,
				borderRadius: theme.roundness * themeRoundnessMultiplier,
				// borderWidth: showBorder ? size * 0.02 : 0,
				borderColor: theme.colors.onPrimaryContainer,
			}}
			cachePolicy={"memory"}
			contentFit="contain"
			alt={"Product Icon"}
			accessibilityLabel={"Product Icon"}
		/>
	);
};

export default ProductIcon;
